module.exports = __webpack_public_path__ + "img/11_uk.a1135171.svg";